/**
 * THIS FILE IS AUTOMATICALLY GENERATED BY genColors.js.
 *
 * DO NOT MANUALLY MODIFY THIS FILE.
 */

enum ColorVariableLightModeName {
  AliceBlue = "--color-aliceBlue-lightMode",
  AntiFlashWhite = "--color-antiFlashWhite-lightMode",
  ArtistPillShadow = "--color-artistPillShadow-lightMode",
  BackgroundOverlay = "--color-backgroundOverlay-lightMode",
  BackgroundOverlayDark = "--color-backgroundOverlayDark-darkMode",
  BlueGradient = "--color-blueGradient-lightMode",
  BrightGray = "--color-brightGray-lightMode",
  BrightPurple = "--color-brightPurple-lightMode",
  CadmiumGreen = "--color-cadmiumGreen-lightMode",
  CardBackground = "--color-cardBackground-lightMode",
  ClickableAreaBackground = "--color-clickableAreaBackground-lightMode",
  Cultured = "--color-cultured-lightMode",
  DarkCerulean = "--color-darkCerulean-lightMode",
  DarkGunmetal = "--color-darkGunmetal-lightMode",
  DarkPurple = "--color-darkPurple-lightMode",
  Dimmer = "--color-dimmer-lightMode",
  Error = "--color-error-lightMode",
  FloatingElement = "--color-floatingElement-lightMode",
  Footer = "--color-footer-lightMode",
  Ghost = "--color-ghost-lightMode",
  Green = "--color-green-lightMode",
  GreenGradient = "--color-greenGradient-lightMode",
  GreenishGray = "--color-greenishGray-lightMode",
  LightBlue = "--color-lightBlue-lightMode",
  LightPink = "--color-lightPink-lightMode",
  LightPurple = "--color-lightPurple-lightMode",
  LightPurpleGradient = "--color-lightPurpleGradient-lightMode",
  LightPurpleHover = "--color-lightPurpleHover-lightMode",
  LightPurpleVerticalGradient = "--color-lightPurpleVerticalGradient-lightMode",
  LinkWater = "--color-linkWater-lightMode",
  MaximumRed = "--color-maximumRed-lightMode",
  MediumBlue = "--color-mediumBlue-lightMode",
  MenuPopup = "--color-menuPopup-lightMode",
  MidnightBlue = "--color-midnightBlue-lightMode",
  Navy = "--color-navy-lightMode",
  NavyHover = "--color-navyHover-lightMode",
  OverlayButton = "--color-overlayButton-lightMode",
  PhantomPurple = "--color-phantomPurple-lightMode",
  Pink = "--color-pink-lightMode",
  PinkVerticalGradient = "--color-pinkVerticalGradient-lightMode",
  PopheadzDarkGray = "--color-popheadzDarkGray-lightMode",
  PopheadzLightGray = "--color-popheadzLightGray-lightMode",
  Primary = "--color-primary-lightMode",
  ProgressBar = "--color-progressBar-lightMode",
  Purple = "--color-purple-lightMode",
  PurpleGradient = "--color-purpleGradient-lightMode",
  PurpleGradientForText = "--color-purpleGradientForText-lightMode",
  PurpleGradientHover = "--color-purpleGradientHover-lightMode",
  Red = "--color-red-lightMode",
  RedGradient = "--color-redGradient-lightMode",
  RedHover = "--color-redHover-lightMode",
  Scheme11 = "--color-scheme11-lightMode",
  Scheme12 = "--color-scheme12-lightMode",
  Scheme21 = "--color-scheme21-lightMode",
  Scheme22 = "--color-scheme22-lightMode",
  Scheme31 = "--color-scheme31-lightMode",
  Scheme32 = "--color-scheme32-lightMode",
  Scheme41 = "--color-scheme41-lightMode",
  Scheme42 = "--color-scheme42-lightMode",
  Scheme51 = "--color-scheme51-lightMode",
  Scheme52 = "--color-scheme52-lightMode",
  Scheme61 = "--color-scheme61-lightMode",
  Scheme62 = "--color-scheme62-lightMode",
  Seashell = "--color-seashell-lightMode",
  Secondary = "--color-secondary-lightMode",
  Shader = "--color-shader-lightMode",
  Sinopia = "--color-sinopia-lightMode",
  SkeletonBase = "--color-skeletonBase-lightMode",
  SkeletonHighlight = "--color-skeletonHighlight-lightMode",
  SpotlightOverlay = "--color-spotlightOverlay-lightMode",
  Tertiary = "--color-tertiary-lightMode",
  Transparent = "--color-transparent-lightMode",
  WebsiteBackground = "--color-websiteBackground-lightMode",
  White = "--color-white-lightMode",
  Yellow = "--color-yellow-lightMode",
}

export default ColorVariableLightModeName;
